<template>
  <div>
    <h2 style="margin-bottom: 10px;margin-left: 25px;font-weight: 300">{{ $t('common.struct') }}</h2>
    <v-treeview
      v-if="items"
      :items="items"
    >
    <!-- <v-treeview
      v-if="items"
      open-all
      :items="items"
    > -->
      <template v-slot:prepend="{ item, open }">
        <v-icon v-if="!item.file">
          <!-- {{ open ? 'mdi-folder-edit-outline' : 'mdi-folder-edit' }} -->
          mdi-folder-edit
        </v-icon>
        <v-icon
          v-else
          :style="{ 'font-weight': item.isTitle ? '700' : '300',
            'font-size': item.isContent ? '16px' : '20px',
            'color': item.common || item.common === 1 ? '#00000033' : ''
          }"
        >
          {{ item.common || item.common === 1 ? 
          'mdi-lock'
          :
          files[item.file].concat(item.children && item.children.length > 0 || item.isContent ? '' : '-outline') }}
        </v-icon>
      </template>
      <template v-slot:label="{ item, open }">
        <v-tooltip
          left
        > 
          <template v-slot:activator="{ on }">
            <div v-on="item.isNew ? on : null">
              <v-btn
                text
                small
                :disabled="item.isNew || (item.common || item.common === 1) ? true : false" 
                @click="onSelectNode(item.isContent ? item.menuID : item.id, item.isSecundary, item.isContent, item.MenuID, item.isContent ? item.id : null)"
                
              >
              
                <span
                  v-if="!item.Availability || (item.Availability.status.date && item.Availability.status.time)"
                  :style="{ 'font-weight': item.isTitle ? '700' : '300',
                            'font-size': item.isContent ? '11px' : '12px',
                            'color': item.isTitle ? 'red' : null,
                            'text-transform': item.isContent ? 'uppercase' : 'uppercase',
                          }"
                >

                  {{ item.name }}
                </span>
                <span
                  v-else
                  :style="{ 'font-weight': item.isTitle ? '700' : '300',
                            'font-size': item.isContent ? '11px' : '12px',
                            'color': item.isTitle ? 'red' : null,
                            'text-transform': item.isContent ? 'uppercase' : 'uppercase',
                          }"
                >
                  
                  <strike>{{ item.name }}</strike>
                </span>
              </v-btn>
            </div>
            </template>
          <span>{{ $t('menus.info.saveBeforeEdit') }}</span>
        </v-tooltip>
      </template>
    </v-treeview>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      onSelectNode: {
        type: Function,
        required: false,
        default: null
      },
      enterpriseID: {
        type: String,
        required: true
      },
      // Utilizado en el forzado de actaulizacion de los datos del arbol de contenido
      updateCustomTree : {
        type: Boolean,
        required: true
      },
      onUpdate: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      selection: null,
      open: ['public'],
      files: {
        html: 'mdi-file-document-edit',
        js: 'mdi-nodejs',
        json: 'mdi-json',
        md: 'mdi-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        menu: 'mdi-menu',
        plus: 'mdi-plus',
        down: 'mdi-subdirectory-arrow-right'
      },
      tree: [],
      items: null,
      contents: null
    }),
    computed: {
        ...mapState('app',['locale']),
       isCommonMenus () {
        // para saber si son menús comunes entre empresas
        return this.$route.path.indexOf('/common-menus') >= 0 ? true : false
      },
    },
    watch:{
      $route (to, from){
        if (to.path && to.path !== from.path) {
          if (to.path.length > 0) {
            this.getData(this.isCommonMenus ? '0000' : this.enterpriseID)
          }
        }
      },
      updateCustomTree (newValue, oldValue) {
        // Utilizado en el forzado de actaulizacion de los datos del arbol de contenido
        if (oldValue !== newValue && newValue) this.getData(this.isCommonMenus ? '0000' : this.enterpriseID)
      }
    },
    mounted () {
      this.getData(this.isCommonMenus ? '0000' : this.enterpriseID)
    },
    methods: {
      getData (enterpriseID) {
        api.getAll(`menus/tree/${enterpriseID}`, true, 1, 100000, '').then(response => {

          response = response.map (item => {
            if (item.Menus) {
              item.Menus = item.Menus.map (submenu => {
                submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
                return submenu
              })
            }
            item.Availability = utils.checkAvailabilityStatus(item.Availability)
            return item
          })
          const mainMenu = response.filter(x => !x.ParentID)
          this.contents = response
          const aux = []
          for (let i = 0; i < mainMenu.length; i++) {
            mainMenu[i].Menus = response.filter(x => x.ParentID === mainMenu[i].ID)
            aux.push(this.convertMenus(mainMenu[i]))
          }
          this.items = aux

          this.onUpdate () // Utilizado en el forzado de actaulizacion de los datos del arbol de contenido
        })
      },
      convertMenus (item) {
        // item.Availability = item.IsTemp && item.Availability ? JSON.parse(item.Availability) : null        
        item.Name = JSON.parse(item.Name)
        let children = []
        if (item.Menus && item.Menus.length > 0) {
          children = this.convertSubMenus(item.Menus)
        } else {
          // console.log(item.ID)
          const aux = item.Contents
          if (aux.length > 0)
            for (let i=0; i < aux.length; i++) {
              let contentName = ''
              if (aux[i].Type !== 27) contentName = constants.menuType.filter(x => x.id === aux[i].Type)
              // else contentName = aux[i].FoodName ? utils.getTranslation(JSON.parse(aux[i].FoodName), this.locale) : ''
              children.push({
                id: aux[i].ID,
                menuID: aux[i].MenuID,
                name: aux[i].Type !== 27
                  ? this.$t(contentName && contentName.length > 0 ? `menuType.${contentName[0].name}` : '')
                  : aux[i].FoodName ?  utils.getStringETC(utils.getTranslation(JSON.parse(aux[i].FoodName), this.locale), 20) : ''
                  ,
                file: 'down',
                isContent: true,
                isNew: false,
                isActive: true,
                common: false
              })
            }          
        }
        return ({
          id: item.ID,
          name: utils.getTranslation(item.Name,'es').substring(0, 20).concat(utils.getTranslation(item.Name, 'es').length > 20 ? '...' : ''),
          file: !item.Menus || item.Menus.length === 0 ? 'html' : null,
          children: children,
          isSecundary: false,
          isNew: item.isNew,
          isActive: item.IsActive,
          Availability: item.Availability,
          common: item.Common
        })
      },
      convertSubMenus (items) {
        const aux = []
        if (items)
          for (let i = 0; i < items.length; i++) {
            items[i].Name = JSON.parse(items[i].Name)
            const children = []
            const contents = items[i].Contents
            if (contents.length > 0)
              for (let i=0; i < contents.length; i++) {
                let contentName = ''
                if (contents[i].Type !== 27) contentName = constants.menuType.filter(x => x.id === contents[i].Type)
                // const contentName = constants.menuType.filter(x => x.id === contents[i].Type)
                children.push({
                  id: contents[i].ID,
                  menuID: contents[i].MenuID,
                  // name: this.$t(contentName.length > 0 ? `menuType.${contentName[0].name}` : ''),
                  name: contents[i].Type !== 27
                  ? this.$t(contentName && contentName.length > 0 ? `menuType.${contentName[0].name}` : '')
                  : contents[i].FoodName ? utils.getStringETC(utils.getTranslation(JSON.parse(contents[i].FoodName), this.locale), 20) : ''
                  ,
                  file: 'down',
                  isContent: true,
                  isSecundary: true,
                  isNew: false,
                  isActive: true,
                  common: false
                })
              }   
            aux.push({
              id: items[i].ID,
              name: utils.getTranslation(items[i].Name, 'es').substring(0, 20).concat(utils.getTranslation(items[i].Name, 'es').length > 20 ? '...' : ''),
              file: 'html',
              isSecundary: true,
              isNew: items[i].isNew,
              isActive: items[i].IsActive,
              common: items[i].Common,
              children: children,
            })
          }
        return aux//.length > 0 ? aux : null
      }
    }
  }
</script>
<style>
  .v-treeview-node__root {
    min-height: 0px;
  }
</style>
